
import {
  FETCH_WAITERS_REQUEST,
  FETCH_WAITERS_SUCCESS,
  FETCH_WAITERS_FAILURE,
  CREATE_WAITER_REQUEST,
  CREATE_WAITER_SUCCESS,
  CREATE_WAITER_FAILURE,
  UPDATE_WAITER_REQUEST,
  UPDATE_WAITER_SUCCESS,
  UPDATE_WAITER_FAILURE,
  DELETE_WAITER_REQUEST,
  DELETE_WAITER_SUCCESS,
  DELETE_WAITER_FAILURE,
} from "./waitersActionsType";

export const fetchWaitersRequest = () => ({
  type: FETCH_WAITERS_REQUEST,
});

export const fetchWaitersSuccess = (data, dataType) => ({
  type: FETCH_WAITERS_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchWaitersFailure = (error) => ({
  type: FETCH_WAITERS_FAILURE,
  payload: error,
});

export const createWaiterRequest = () => ({
  type: CREATE_WAITER_REQUEST,
});

export const createWaiterSuccess = (data, dataType) => ({
  type: CREATE_WAITER_SUCCESS,
  payload: { data, type: dataType },
});

export const createWaiterFailure = (error) => ({
  type: CREATE_WAITER_FAILURE,
  payload: error,
});

export const updateWaiterRequest = () => ({
  type: UPDATE_WAITER_REQUEST,
});

export const updateWaiterSuccess = (data, dataType) => ({
  type: UPDATE_WAITER_SUCCESS,
  payload: { data, type: dataType },
});

export const updateWaiterFailure = (error) => ({
  type: UPDATE_WAITER_FAILURE,
  payload: error,
});

export const deleteWaiterRequest = () => ({
  type: DELETE_WAITER_REQUEST,
});

export const deleteWaiterSuccess = (data, dataType) => ({
  type: DELETE_WAITER_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteWaiterFailure = (error) => ({
  type: DELETE_WAITER_FAILURE,
  payload: error,
});
